var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsDown = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-180 8.54854 8)",
  fill: "currentColor",
  d: "m7.06606,2.19223c0.12111,-0.26914 0.38881,-0.44223 0.68394,-0.44223l0.5,0c1.24264,0 2.25,1.00736 2.25,2.25l0,2.25l2.8456,0c1.203,0 2.0473,1.18567 1.6538,2.32244l-1.5577,4.49996c-0.244,0.7049 -0.9079,1.1776 -1.6538,1.1776l-8.5379,0c-0.69036,0 -1.25,-0.5596 -1.25,-1.25l0,-5c0,-0.69036 0.55964,-1.25 1.25,-1.25l1.76506,0l2.051,-4.55777zm-2.31606,6.05777l-1.25,0l0,4.5l1.25,0l0,-4.5zm1.5,4.5l5.5379,0c0.1066,0 0.2014,-0.0675 0.2363,-0.1682l1.5577,-4.50002c0.0562,-0.1624 -0.0644,-0.33178 -0.2363,-0.33178l-3.5956,0c-0.41421,0 -0.75,-0.33579 -0.75,-0.75l0,-3c0,-0.41421 -0.33579,-0.75 -0.75,-0.75l-0.01506,0l-1.98494,4.41098l0,5.08902z",
  clipRule: "evenodd",
  fillRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsDown);
export default ForwardRef;